import CrystalsHeader from "./items/CrystalsHeader";
import CryptoAndCrystalHeader from "./items/CryptoAndCrystalHeader";
import OnlyCryptoHeader from "./items/OnlyCryptoHeader";

export default function PromoForm({ Type }) {
    let header = <CrystalsHeader />;

    if (Type === 'onlyCrypto') {
        header = <OnlyCryptoHeader />;
    } else if (Type === 'crtysalAndCrypto') {
        header = <CryptoAndCrystalHeader />;
    } else if (Type === 'crystals') {
        header = <CrystalsHeader />;
    }

    return (
        <div className="w-full">
            {header}
        </div>
    );
}
